<span *ngFor="let part of textParts" [ngStyle]="getPartStyle(part.isHighlighted)">{{part.text}}</span>